import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { generateActivityLogDetails } from "./utils";
import useLocationsActivity from "../../../containers/FacilityDetailsPage/hooks/useLocationsActivity";
import { LocationActivityLog } from "../../../models/LocationActivityLog";
import { LocationActivityQueryParams } from "../../LocationActivityComponents/LocationActivityTable/types";

import "./styles.scss";

export interface IActivityLogProps {
  locationId: string;
  locationName?: string;
}

export const ActivityLog: React.FunctionComponent<IActivityLogProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`facilityDetailsPage.activityLog.${key}`);

  const { locationId, locationName } = props;

  const queryParams: LocationActivityQueryParams = {
    location_id: locationId,
    limit: 3,
    offset: 0,
    sort: "activity_date",
    order: "desc",
  };
  const { data: activityLogs } = useLocationsActivity(queryParams);

  return (
    <div className="activity-log white-border-panel">
      <div className="titles">
        <span className="title">{t("activity_log")}</span>
        <span className="note">{t("activity_log_note")}</span>
      </div>
      <ul className="activity-log-list">
        {activityLogs?.data.map((activityLog: LocationActivityLog) => (
          <li key={activityLog.id}>
            <div>
              <span>
                {dayjs(activityLog.activity_date).format("YYYY/MM/DD")}
              </span>
              <span>{generateActivityLogDetails(activityLog)}</span>
            </div>
          </li>
        ))}
      </ul>
      <div className="view-more">
        <Link
          className="btn btn-blue"
          to={`/activity/locations${
            locationName ? `?locationName=${locationName}` : ""
          }`}
        >
          {t("view_more")}
        </Link>
      </div>
    </div>
  );
};
